import { selectAllV2NonStreamingApiNames } from "legacy/selectors/sagaSelectors";

import { selectAllV2ApiNames } from "../../apisV2/selectors";

export const selectAllApiUnionNames = selectAllV2ApiNames;

export const selectAllNonStreamingApiUnionNames =
  selectAllV2NonStreamingApiNames;

export * from "./controlFlowEnabledDynamic";
